const apiUrl = (process.env.NODE_ENV === 'production')
? "https://api.salonacme.com/manager/"
: "https://api.salonacme.com/manager/";

module.exports = apiUrl;